import Box from "@mui/material/Box";
import { useContext, useEffect, useRef, useState } from "react";
import { useController } from "react-hook-form";
import TypesenseInstantSearch from "components/context/TypesenseInstantSearch";
import { FormContext } from "components/shared/Form";
import {
  StyledTextField,
  TypesenseAutocomplete,
  optionEqualsToValueById,
} from "components/ui/atoms/SelectAutocomplete";

const GenericModelField = ({
  name,
  multiple,
  label,
  indexName,
  getOptionLabel,
  getObectFromIdAsync,
  renderOption,
  renderTags,
  CreateButton,
}) => {
  const {
    form: { control },
  } = useContext(FormContext);
  const {
    field: { ref, value, onChange, ...otherFields },
    fieldState,
  } = useController({
    control: control,
    name: name,
  });
  const empty = useRef(multiple ? [] : null);
  const [innerValue, setInnerValue] = useState(undefined);

  useEffect(() => {
    if (value === undefined) setInnerValueWithoutDoublon(empty.current);
    else if (multiple)
      setInnerValueWithoutDoublon(value.map((v) => ({ id: v })));
    else {
      value === null
        ? setInnerValueWithoutDoublon(null)
        : getObectFromIdAsync(value).then((response) =>
            setInnerValueWithoutDoublon(response),
          );
    }
  }, [value]);

  const addIfNotInArray = (array, v) => {
    if (array.indexOf(v) > -1) return array;
    return [...array, v];
  };

  const setInnerValueWithoutDoublon = (value) => {
    if (!multiple) {
      return setInnerValue(value);
    }
    const res = [];
    const seen = new Set();
    for (let v of value) {
      if (seen.has(v.id)) continue;
      seen.add(v.id);
      res.push(v);
    }
    return setInnerValue(res);
  };

  useEffect(() => {
    if (innerValue === undefined) return;
    if (multiple) {
      const new_value = innerValue.reduce(
        (s, v) => addIfNotInArray(s, v.id),
        [],
      );
      if (JSON.stringify(new_value) !== JSON.stringify(value))
        onChange(new_value);
    } else {
      onChange(innerValue?.id || null);
    }
  }, [innerValue]);

  return (
    <>
      <TypesenseInstantSearch indexName={indexName}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-end",
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
            }}
          >
            <TypesenseAutocomplete
              {...otherFields}
              multiple={multiple}
              value={innerValue || empty.current}
              onChange={(event, data) => {
                const new_data = data === null ? empty.current : data;
                setInnerValueWithoutDoublon(new_data);
              }}
              renderInput={(params) => (
                <StyledTextField
                  {...params}
                  ref={ref}
                  variant="standard"
                  helperText={fieldState.error?.message}
                  error={fieldState.invalid}
                  label={label || "Label"}
                />
              )}
              getOptionLabel={getOptionLabel}
              renderOption={renderOption}
              renderTags={renderTags}
              isOptionEqualToValue={optionEqualsToValueById}
            />
          </Box>
          {CreateButton && (
            <Box
              sx={{
                flexGrow: 0,
                pl: 2,
              }}
            >
              <CreateButton />
            </Box>
          )}
        </Box>
      </TypesenseInstantSearch>
    </>
  );
};

export default GenericModelField;
